/**
 * En-tête d'identification de la borne.
 *
 * Le JWT porte déjà l'identifiant de la borne, mais il circule seul : recopié
 * ailleurs, il vaudrait autant que sur l'écran mural. L'en-tête accompagne
 * chaque requête du **jeton de l'appareil**, celui qui a été provisionné dans ce
 * navigateur — un jeton volé ne suffit alors plus, il faut aussi l'appareil.
 *
 * Il sert accessoirement à tenir à jour la date de dernier contact d'une borne,
 * qui sans cela ne s'actualiserait qu'à l'ouverture de session.
 */
export const KIOSK_TOKEN_HEADER = 'x-kiosk-token';
